import { ONE_SECOND } from './constants';

export const IMPORT_STATUS_STARTED = 1;
export const IMPORT_STATUS_CANCELED = 2;
export const IMPORT_STATUS_FAILED = 3;
export const IMPORT_STATUS_COMPLETED = 4;
export const ADMIN_IMPORT_STATUS_COMPLETED = 5;

export const IMPORT_GET_PARTNER_INTERVAL = ONE_SECOND * 5;

export const REPORT_JOB_STATUS = [IMPORT_STATUS_CANCELED, IMPORT_STATUS_FAILED, IMPORT_STATUS_COMPLETED, ADMIN_IMPORT_STATUS_COMPLETED];
export function isJobReportPending(job: Job.IJobExport) {
    return REPORT_JOB_STATUS.indexOf(job.status) === -1;
}